const $ = require('jquery');
require('select2');

const filterType = $('#city');
const filterSeason = $('#season');
const filterDesigner = $('#designers');
const filterTags = $('#tags');
const filterIndividual = $('#individual');
const filterTagIcon = $('.filter-tags .fa-search');
const lang = document.documentElement.lang;


module.exports = function initFilters() {
    filterType.select2({
        allowClear: true,
        placeholder: filterType.attr('data-placeholder')
    });
    filterType.on('change.select2', filterChange);

    filterSeason.select2({
        allowClear: true,
        placeholder: filterSeason.attr('data-placeholder')
    });
    filterSeason.on('change.select2', filterChange);

    filterDesigner.select2({
        placeholder: filterDesigner.attr('data-placeholder'),
        allowClear: true
    });
    filterDesigner.on('change.select2', filterChange);

    filterIndividual.select2({
        placeholder: filterIndividual.attr('data-placeholder'),
        allowClear: true,
    });
    filterIndividual.on('change.select2', filterChange);

    filterTags.select2({
        placeholder: filterTags.attr('data-placeholder'),
        minimumInputLength: filterTags.attr('data-minimum') || 0,
        ajax: {
            url: filterTags.attr('data-path'),
            dataType: 'json',
            delay: 300,
            data: function (params) {
                return  {
                    search: params.term,
                    page: params.page || 1,
                    language: lang
                };
            },
            processResults: function (data, params) {
                // Transforms the top-level key of the response object from 'items' to 'results'
                let results = [];

                for (let i = 0; i < data.results.length; i++) {
                    results[i] = {
                        id: data.results[i]['slug'],
                        text: data.results[i]['suggest'].join(' / ')
                    }
                }

                params.page = params.page || 1;

                return {
                    results: results,
                    pagination: {
                        more: (params.page * 10) < data['total_count']
                    }
                };
            }
        }
    });

    filterTags.on('change.select2', filterChange);

    if (filterTags.length && filterTags.val().length > 0) {
        filterTagIcon.addClass('d-none');
    }

    filterTagIcon.on('click', () => {
        filterTags.select2('open');
    })

    $('form.filters').on('submit', function () {
        $(this).find('select').each(function () {
            if (!$(this).val()) {
                $(this).prop('disabled', true);
            }
        })
    });
};

function filterChange() {
    $('form.filters').trigger('submit');
    $('.filter select').prop('disabled', true);
}
